import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../utils/api';

export default function TemplatesPage() {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [creating, setCreating] = useState(false);
  const [msg, setMsg] = useState('');

  const load = () => {
    api.templates.list()
      .then(d => setTemplates(Array.isArray(d) ? d : []))
      .catch(() => setTemplates([]))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const handleCreate = async () => {
    if (!name.trim()) return;
    setCreating(true);
    try {
      await api.templates.create({ name: name.trim(), description: description.trim() });
      setName(''); setDescription('');
      setMsg('Template created!');
      setTimeout(() => setMsg(''), 3000);
      load();
    } catch (e) {
      setMsg('Error: ' + e.message);
    } finally {
      setCreating(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this template?')) return;
    try {
      await api.templates.delete(id);
      load();
    } catch (e) {
      alert('Error: ' + e.message);
    }
  };

  return (
    <div style={{ maxWidth: 700, margin: '0 auto', padding: 32 }}>
      <Link to="/" style={{ fontSize: 13, color: 'var(--text-muted)', textDecoration: 'none' }}>← Back</Link>
      <h1 style={{ marginTop: 16, marginBottom: 4, fontSize: 22 }}>Session Templates</h1>
      <p style={{ color: 'var(--text-muted)', fontSize: 13, marginBottom: 24 }}>Save recurring session configurations as templates.</p>

      {/* Create form */}
      <div className="card mb-4">
        <h3 style={{ fontSize: 14, marginBottom: 12 }}>New Template</h3>
        <input
          className="input mb-2"
          placeholder="Template name"
          value={name}
          onChange={e => setName(e.target.value)}
          style={{ fontSize: 13 }}
        />
        <input
          className="input mb-3"
          placeholder="Description (optional)"
          value={description}
          onChange={e => setDescription(e.target.value)}
          style={{ fontSize: 13 }}
        />
        <button className="btn btn-primary" onClick={handleCreate} disabled={creating || !name.trim()}>
          {creating ? 'Creating...' : '+ Create Template'}
        </button>
        {msg && <div className="toast toast-success mt-2">{msg}</div>}
      </div>

      {/* Template list */}
      {loading ? (
        <div style={{ color: 'var(--text-muted)' }}>Loading...</div>
      ) : templates.length === 0 ? (
        <div style={{ color: 'var(--text-muted)', fontStyle: 'italic' }}>No templates yet.</div>
      ) : templates.map(t => (
        <div key={t.id} className="card mb-2" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <div style={{ fontWeight: 600 }}>{t.name}</div>
            {t.description && <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>{t.description}</div>}
          </div>
          <button className="btn btn-ghost btn-sm" onClick={() => handleDelete(t.id)} style={{ color: '#e05252' }}>Delete</button>
        </div>
      ))}
    </div>
  );
}
